// src/components/Hero.js
import React from 'react';
import { Box } from '@mui/material';
import BreadcrumbsNav from './BreadcrumbsNav';
import heroImg from '../assets/img-hero.jpg';

const Hero = ({ children, padding = 4 }) => {
  return (
    <Box sx={{ position: 'relative' }}>

      <Box
        sx={{
          height: 200,
          backgroundImage: `url(${heroImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 16,
            left: 16,
            bgcolor: 'rgba(255,255,255,0.7)', 
            borderRadius: 1,
            px: 2,
            py: 0.5,
          }}
        >
          <BreadcrumbsNav />
        </Box>
      </Box>

      <Box sx={{ bgcolor: '#ECF3E0', minHeight: 70 }} />

      {/* Contenido flotante */}
            <Box
            sx={{
                position: 'absolute',
                top: { xs: 100, sm: 100 }, 
                left: 0,
                right: 0,
            }}
            >
            <Box maxWidth={900} mx="auto" px={2}>
                {children}
            </Box>
            </Box>

    </Box>
  );
};

export default Hero;
